import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CountUp from 'react-countup';
import JackpotModal from './JackpotModal';
import classes from './JackpotHomepageModal.module.scss';
import closeImg from '../../../../shared/assets/images/jackpot/jp-close.png';
import bannerImg from '../../../../shared/assets/images/jackpot/jp-homepage-banner.png';
import counterImg from '../../../../shared/assets/images/jackpot/jp-homepage-banner-counter.png';
import { removeJackpotWonNotifications, selectJackpotWonData, selectJackpotWonBalance } from '@homeplay/app';
import { formatBalance } from '@homeplay/utils';

const JackpotHomepageModal = () => {
  const dispatch = useDispatch();
  const wonData = useSelector(selectJackpotWonData);
  const totalBalance = useSelector(selectJackpotWonBalance);

  if (!wonData) return null;

  const handleClose = () => {
    dispatch(removeJackpotWonNotifications());
  };

  //NOTE: No modalClose, only close button
  return (
    <JackpotModal customClass={classes.Root}>
      <button className={classes.CloseBtn} onClick={handleClose}>
        <img src={closeImg} alt="close jackpot" />
      </button>

      <div className={classes.MainWrapper}>
        <img className={classes.Banner} src={bannerImg} alt="jackpot banner" draggable={false} />
        
        {/* Counter is positioned relative to the image */}
        <img className={classes.CounterImage} src={counterImg} alt="jackpot counter" draggable={false} />
        <div className={classes.Counter}>
          <CountUp
            duration={5}
            start={0}
            end={totalBalance || wonData.balance || 0}
            delay={0.5}
            formattingFn={(value) => formatBalance(value)}
          />
        </div>
      </div>
    </JackpotModal>
  );
};

export default React.memo(JackpotHomepageModal);


